'use strict';

module.exports = function AffiliateTeamIdentityProvider(params) {
	if (!params) {
		throw new Error('invalid-args');
	}
	const self = this,
		{affiliateProviders, subscriptionModel} = params,
		getAffiliatedProvider = (goldAccountInfo, requiredAction) => {
			if (!goldAccountInfo || !goldAccountInfo.provider || !goldAccountInfo.providerProfile || !goldAccountInfo.subscription || !goldAccountInfo.subscription.actions || !goldAccountInfo.subscription.actions.includes(requiredAction)) {
				return false;
			}
			return affiliateProviders.find(prov => prov.supports(goldAccountInfo.provider));
		};

	if (!subscriptionModel || !affiliateProviders || !Array.isArray(affiliateProviders) || !affiliateProviders.length) {
		throw new Error('invalid-args');
	}
	self.getAffiliateTeamIdentity = async () => {
		const goldAccountInfo = await subscriptionModel.getGoldAccountDetails(false, true),
			affiliatedProvider = getAffiliatedProvider(goldAccountInfo, 'UseAffiliateTeams');
		if (!affiliatedProvider) {
			return false;
		}
		return affiliatedProvider.getTeamIdentity(goldAccountInfo.providerProfile);
	};

	self.enableMicrosoftTeams = async (callOptions) => {
		const goldAccountInfo = await subscriptionModel.getGoldAccountDetails(false, true),
			affiliatedProvider = getAffiliatedProvider(goldAccountInfo, 'EnableMicrosoftTeams'),
			affiliatedTeamIdentity = affiliatedProvider && await affiliatedProvider.getTeamIdentity(goldAccountInfo.providerProfile, Object.assign({popupAuthEvent: 'popup-auth-required-pre', disableSkipping: true}, callOptions));
		if (!affiliatedTeamIdentity) {
			//TODO, show some message
			return false;
		}
		return subscriptionModel.enableMicrosoftTeams();

	};
};
